module.exports = __webpack_public_path__ + "img/reviews-img-1-test.2f15ef9e.jpeg";